import { getTimePanelSelectedCalendarIdsMap } from './getSelectedCalendarIdsMap';
import { flattenObservableMapValues } from 'owa-selected-calendars-utils';

export function getTimePanelSelectedCalendarIdsFlatList(): string[] {
    return flattenObservableMapValues(getTimePanelSelectedCalendarIdsMap());
}
